import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  apiCallSSOCommon,
  callAPIInterface,
  handleAfterLoginProcess,
  setUpdatedSessionData,
  ssoData,
} from "./constants";
import BackdropLoader from "./backdropLoader/BackdropLoader";
import { authenticatingURL, SIGN_UP_PAGE } from "./messages";

function SocialMediaAuth(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const search = useLocation().search;

  const { signupMethod, authCode, decodedAuthState, userData } = ssoData(
    location,
    search
  );

  const redirectToLogin = async () => {
    navigate("/login");
  };

  const handleProcessAfterSSO = async (response) => {
    await setUpdatedSessionData(response);

    const sessionState = response?.session_state;

    if (sessionState === "mfa_in_progress") {
      const redirect2faPage = response.mfa_configurations
        ? "/two-factor"
        : "/two-factor-setup";
      navigate(redirect2faPage, { state: { from: "/login" } });
    } else if (sessionState === "trusted_device_in_progress") {
      navigate("/unrecognized-device");
    } else {
      await handleAfterLoginProcess(navigate);
    }
  };

  useEffect(() => {
    let apiPayload = apiCallSSOCommon({
      decodedAuthState,
      authCode,
      redirectFn: redirectToLogin,
      signupMethod,
      userData,
    });

    if (apiPayload) {
      const ssoEndpoint =
        decodedAuthState?.from === SIGN_UP_PAGE ? "/sso-signup" : "/sso-login";

      callAPIInterface("POST", ssoEndpoint, apiPayload)
        .then((response) => {
          handleProcessAfterSSO(response);
        })
        .catch((err) => {
          redirectToLogin();
        });
    }
  }, []);

  return (
    <BackdropLoader
      open={true}
      alt="Loading..."
      customClass="loading-in-auth"
      text={authenticatingURL}
    />
  );
}

export default SocialMediaAuth;
